import { render, staticRenderFns } from "./chooseInput.vue?vue&type=template&id=1f336cb2"
import script from "./chooseInput.vue?vue&type=script&lang=js"
export * from "./chooseInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports